export const ShiftRegistrationVI = {
    "shiftRegistrationSider": {
        "shiftRoster": "Bảng đăng kí ca tháng"
    },
    "shiftRegistrationTitle": {
        "STT": "TT",
        "ID": "Mã NV",
        "fullName": "Họ và Tên",
        "department": "Phòng ban",
        "jobPosition": "Vị trí",
        "totalPoints": "Công tổng",
        "points": "Số công",
        "hour": "Tổng giờ",
        "standardPoints": "Công chuẩn"
    },
    "shiftRegistrationDetail": {
        "shiftWork": "Ca làm việc:",
        "shiftWorkName": "Tên ca:",
        "shiftWorkCode": "Mã ca:",
        "shiftWorkTime":"Thời gian vào ra:",
        "timeNotExist": "Không có",
        "date": "Ngày",
        "status": "Trạng thái:",
        "draft" : "Draft",
        "pending" : "Pending",
        "approved" : "Approved",
        "denied" : "Denied",
        "expired" : "Expired",
        "inactive" : "Inactive",
        "incomplete" : "Incomplete"
    }
}